import { supplierApi } from 'apiClient';
import {
  SET_SUPPLIERS,
  SET_SUPPLIERS_FAILED,
  SET_SUPPLIERS_LOADING,
  SET_SELECTED_SUPPLIER,
} from '@/store/mutationTypes';
import ApiLoadingStatus from '@/api/statusTypes';
import { GET_SUPPLIERS_ACTION, GET_SUPPLIER_BY_CREDITOR_ID_ACTION } from '@/store/actionTypes';
import SearchValidationError from '@/errors/searchValidationError';

export default {
  state: {
    all: [],
    status: null,
    selectedSupplier: null,
    isSupplierFetching: false,
    supplierStatus: null,
  },
  mutations: {
    [SET_SUPPLIERS](state, suppliers) {
      state.all = suppliers || [];
      state.status = suppliers ? ApiLoadingStatus.STATUS_SUCCESSFUL : null;
    },

    [SET_SUPPLIERS_LOADING](state) {
      state.all = [];
      state.status = ApiLoadingStatus.STATUS_LOADING;
    },

    [SET_SUPPLIERS_FAILED](state) {
      state.all = [];
      state.status = ApiLoadingStatus.STATUS_ERROR_LOADING;
    },

    [SET_SELECTED_SUPPLIER](state, supplier, supplierStatus = null) {
      state.selectedSupplier = supplier;
      state.supplierStatus = supplierStatus;
    },
  },
  actions: {
    async [GET_SUPPLIERS_ACTION]({ commit }, searchString) {
      try {
        commit(SET_SUPPLIERS_LOADING, result);

        let result = await supplierApi.getSuppliers(searchString);

        commit(SET_SUPPLIERS, result);
      } catch (error) {
        if (error instanceof SearchValidationError) {
          return commit(SET_SUPPLIERS, []);
        }
        commit(SET_SUPPLIERS_FAILED);
        throw error;
      }
    },
    async [GET_SUPPLIER_BY_CREDITOR_ID_ACTION]({ commit }, creditorId) {
      try {
        if (!creditorId) return;

        commit(SET_SELECTED_SUPPLIER, null, ApiLoadingStatus.STATUS_LOADING);

        let result = await supplierApi.getSupplierByCreditorId(creditorId);
        commit(SET_SELECTED_SUPPLIER, result, ApiLoadingStatus.STATUS_SUCCESSFUL);
      } catch (error) {
        commit(SET_SELECTED_SUPPLIER, null, ApiLoadingStatus.STATUS_ERROR_LOADING);
        throw error;
      }
    },
  },
  getters: {},
};
